import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m14.7 7.1-6-6c-.4-.4-1-.4-1.4 0l-6 6c-.2.2-.2.5 0 .7s.5.2.7 0l5.5-5.5v12.5c0 .3.2.5.5.5s.5-.2.5-.5V2.3L14 7.8c.1.1.2.1.4.1.1 0 .3 0 .4-.1.1-.2.1-.5-.1-.7" />
  </svg>
);
const SvgArrowUp = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="arrow-up" {...props} />;
export default SvgArrowUp;
